/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SecuritySummary {
  /**
  * Number of clean resources
  */
  'clean': number;
  /**
  * Number of infected resources
  */
  'infected': number;
  /**
  * Number of disabled resources
  */
  'disabled': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "clean",
      "baseName": "clean",
      "type": "number",
      "format": ""
    },
    {
      "name": "infected",
      "baseName": "infected",
      "type": "number",
      "format": ""
    },
    {
      "name": "disabled",
      "baseName": "disabled",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SecuritySummary.attributeTypeMap;
  }

  public constructor() {
  }
}

